<section class="hero-section" aria-labelledby="hero-heading">
  <div class="hero-content">
    <h1 id="hero-heading" class="hero-title">
      믿을 수 있는<br>
      <span class="hero-title-light">부동산 거래</span>
    </h1>
    <p class="hero-subtitle">
      HouseDeal과 함께 안전하고 투명한<br>
      부동산 거래를 경험하세요.
    </p>
    <div class="hero-cta">
      <button type="button" class="btn-primary" (click)="checkPermission()">매물 보기</button>
      <button type="button" class="btn-secondary" (click)="goToSignup()">무료 회원가입</button>
    </div>
  </div>
  <div class="hero-visual" aria-hidden="true">
    <div class="hero-visual-box">
      <div class="visual-stat">
        <span class="stat-number">12,000+</span>
        <span class="stat-label">등록 매물</span>
      </div>
      <div class="visual-divider"></div>
      <div class="visual-stat">
        <span class="stat-number">98%</span>
        <span class="stat-label">고객 만족도</span>
      </div>
    </div>
  </div>
</section>

<section class="service-section" aria-label="주요 서비스">
  <div class="service-grid">
    <article class="service-card">
      <div class="service-card-icon">
        <span class="material-icons">verified_user</span>
      </div>
      <h3>안전한 거래</h3>
      <p>검증된 부동산 정보로 안심하고 거래하세요</p>
    </article>
    <article class="service-card">
      <div class="service-card-icon">
        <span class="material-icons">support_agent</span>
      </div>
      <h3>전문가 상담</h3>
      <p>경험 많은 전문가가 최적의 조건을 찾아드립니다</p>
    </article>
    <article class="service-card">
      <div class="service-card-icon">
        <span class="material-icons">trending_up</span>
      </div>
      <h3>실시간 정보</h3>
      <p>최신 시세와 매물 정보를 실시간으로 확인하세요</p>
    </article>
  </div>
</section>
